import styled from 'styled-components';

export const OTScrollable = styled.div<{ tall?: boolean }>`
  max-height: ${({ tall }) => (tall ? '500px' : '400px')};
  overflow-x: hidden;
  overflow-y: auto;
`;
